import React from 'react'

type PageHeroProps = {
    title: string
    image: string
    imageAlt: string
    imageClassName?: string
}

const PageHero: React.FC<PageHeroProps> = ({ title, image, imageAlt, imageClassName = '' }) => (
    <header className="page-hero">
        <img src={image} className={`page-hero__image ${imageClassName}`.trim()} alt={imageAlt} />
        <div className="page-hero__title">
            <div className="container">
                <h1>{title}</h1>
            </div>
        </div>
    </header>
)

export default PageHero
